import React from 'react';
import Wix from '../../commons/services/Wix';
import { parseStyles, getStyles } from '../../commons/services/styles';

// Wrap a component passing a styles property which is fetched from Wix and updated on changes.
function createStylesContainer(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.onStylesChange = this.onStylesChange.bind(this);

      this.state = {
        styles: null
      };
    }

    onStylesChange(styles) {
      this.setState(() => ({
        styles: parseStyles(styles)
      }));
    }

    componentDidMount() {
      Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, this.onStylesChange);

      getStyles().then(styles => {
        this.setState(() => ({ styles }));
      });
    }

    componentWillUnmount() {
      Wix.removeEventListener(
        Wix.Events.STYLE_PARAMS_CHANGE,
        this.onStylesChange
      );
    }

    render() {
      return <WrappedComponent {...this.state} {...this.props} />;
    }
  };
}

export default createStylesContainer;



// WEBPACK FOOTER //
// ./src/commons/components/createStylesContainer.jsx